<template>
  <div class="yunxiao teacher e-wallet" data-test="e-wallet-page">
    <vx-list
      @load="onLoad"
      class="full-page"
      enable
      :params="params"
      :api="this.$api.getStudentWalletLog"
    >
      <div class="total-nav">
        <div class="total-contain">
          <p class="lable">总余额（{{studentWalletObj.campusWalletList && studentWalletObj.campusWalletList.length}}校区）</p>
          <p class="amount"><span>￥</span>{{(studentWalletObj.walletTotalMoney || 0) | formatNumber}}</p>
          <router-link  class="toPreStoreBtn" :to="'/prestore?type=2&id='+this.studId" data-test="e-wallet-page-btn-">预存</router-link>
          <!-- <router-link class="toPreStoreBtn" :to="'/sf1?type=3&id='+this.studId" data-test="e-wallet-page-btn-">预存</router-link> -->
        </div>
        <div v-if="studentWalletObj.campusWalletList.length" class="campus-detials" :class="{folded: campusDetialsFolded}">
          <div class="campus-amount-item" v-for="campus of studentWalletObj.campusWalletList" :key="campus.campusId">
            {{campus.campusName}}：￥{{campus.money | formatNumber}}
          </div>
          <div class="fold-row" @click="campusDetialsFolded=!campusDetialsFolded">
            <van-icon name="play" />
          </div>
        </div>
      </div>
      <div class="charge-details-nav">
        <div class="title-line">
          明细
          <!-- <van-popover
            v-model="showPopover"
            trigger="click"
            placement="top-start"
            theme="dark"
            :offset="[-8, 4]"
          >
            记录钱包明细，分为预存、交费、退预存余额，按校区统计
            <template #reference>
              <van-icon name="question-o" class="tips-icon" />
            </template>
          </van-popover> -->
          <div class="campus-picker-btn van-ellipsis" @click="pickerCampusList">
            <div class="van-ellipsis" style="max-width: calc(var(--w) * 120)">
              {{ campusText }}
            </div>
            <van-icon name="play" />
          </div>
        </div>
        <van-empty
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          v-if="list.length === 0"
          description="还没有明细～"
          image-size="128">
        </van-empty>

          <div 
            class="charge-log" 
            v-for="(log, idx) of list" 
            :key="idx" 
            @click="toOrderDetails(log)">
            <div class="main-line">
              <span>{{titleArr[log.type]}} {{log.productName ? (':' + log.productName) : ''}}</span>
              <span  class="num" :class="{in: log.money > 0 }">{{log.money > 0 ? '+' : ''}}{{log.money | formatNumber}}</span>
            </div>
            <div class="time-line">
              {{log.campusName}} {{log.createTime | formatDatetime}}
            </div>
          </div>

        

      </div>
    
    </vx-list>
  </div>
</template>

<script>
export default {
  name: 'eWallet',
  filters: {
    formatDatetime (timeStr) {
      return timeStr && new Date(timeStr) ?
      app.tool.date.formatDatetime(new Date(timeStr), 'yyyy-MM-dd hh:mm')
      : '--';
    }
  },
  data () {
    return {
      pageTitle: '电子钱包',
      campusDetialsFolded: true,
      studentWalletObj: {
        campusWalletList: [],
        walletTotalMoney: '',
      },
      list: [
      ],
      showPopover: false,
      campusList: [],
      studId: this.$route.query.id,
      params: {
        studentId: this.$route.query.id,
        campusIds: []
      },
      titleArr: [
        '购买',
        '购买',
        '',
        '结转',
        '转课',
        '结转',
        '',
        '预存',
        '结转',
        '退费',
        '',
      ]
    }
  },
  computed: {
    campusText: function () {
      let cps = this.campusList,
        text = "全部校区";
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    }
  },
  created () {
    this.getStudentWalletInfos();
  },
  methods: {
    onLoad (list) {
      this.list = list
    },
    async pickerCampusList() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.campusList
      });
      this.campusList = res.list;
      this.params.campusIds = res.ids;
    },
    // 查询学员各校区钱包余额
    getStudentWalletInfos () {

      return this.$api.getStudentWalletDetail({
        id: this.studId
      })
      .then(res=>{
        if(res.code === 200 && res.data) {
          Object.assign(this.studentWalletObj, res.data);
        }
      })
      .catch(err=>{
        console.log(err)
      })
    },
    // 查询学员各校区钱包记录
    getStudentWalletLog () {
      this.showLoading();
      return this.$api.getStudentWalletLog({
        studentId: this.studId,
        campusIds: this.campusIds
      })
      .then(res=>{
        this.$toast.clear();
        if(res.code === 200 && res.data) {
          this.list = res.data;
        }
      })
      .catch(err=>{
        console.log(err)
      })
    },
    toOrderDetails (log) {
      this.$router.push(`/orderDetail/${log.orderId}/${log.orderType}/${log.sourceType}`);
    }
  },

}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.e-wallet{

  .total-nav{
    margin: calc(var(--gap) * 16);
    height: auto;
    overflow: hidden;    
    background: var(--white);
    border-radius: var(--radius-sm);
    .total-contain{
      position: relative;
      padding: calc(var(--gap) * 32) calc(var(--gap) * 92) calc(var(--gap) * 16) calc(var(--gap) * 16);
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
      background: var(--c1);
      .lable{
        margin: 0;        
        color: rgba(var(--white-rgb), 0.7);
      }
      .amount{
        margin: calc(var(--gap) * 8) 0 calc(var(--gap) * 16);
        font-size: calc(var(--w) * 32);
        line-height: calc(var(--w) * 36);
        color: var(--white);
        >span{
          font-size:var(--fs-ex1);
          line-height:var(--lh-ex1);
        }
      }
      .toPreStoreBtn{
        position: absolute;
        display: flex;
        height: calc(var(--w) * 32);
        width: calc(var(--w) * 60);
        top: 0;
        bottom: 0;
        margin: auto;
        right: calc(var(--w) * 16);
        background: var(--white);
        border-radius: calc(var(--w) * 16);
        align-items: center;
        justify-content: center;
        color: var(--c1);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        outline: none;
      }
      .toPreStoreBtn:active,
      .toPreStoreBtn:visited{
        color: var(--c1);
      }

    }
    .campus-detials{
      position: relative;
      padding: 0 calc(var(--gap) * 16);
      color: var(--g6);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      .campus-amount-item{
        padding: calc(var(--gap) * 12) 0 0;
        transition: all .3s;
      }
      .fold-row{
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        i{
          margin: calc(var(--gap) * 4) 0;
          transform: rotateZ(-90deg);
          color: var(--g6);
          transition: all .3s;
        }
      }
      &.folded{
        .campus-amount-item{
          padding: 0;
          height: 0;
          overflow: hidden;
        }
        .fold-row i{
          transform: rotateZ(90deg);
        }
      }
    }
  }
  .charge-details-nav{    
    margin: calc(var(--gap) * 16);
    padding: 0 calc(var(--gap) * 16);
    height: auto;
    min-height: 100%;
    overflow: hidden;    
    border-radius: var(--radius-sm);    
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    background: var(--white);
    color: var(--g8);
    .title-line{
      display: flex;
      height: calc(var(--w) * 46);
      align-items: center;
      justify-content: space-between;
      .van-popover__wrapper{
        height: 16px;
        margin: -2px 0 0 3px;
      }
      .campus-picker-btn {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: space-between;
        color: var(--g6);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        i{
          margin-left: calc(var(--gap) * 4);
          transform: rotateZ(90deg);
          transition: all .3s;
        }
      }
    }
    .charge-log{
      position: relative;
      padding:calc(var(--gap) * 16) 0;
      .main-line{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
        // .num{
        //   font-weight: bold;
        // }
        >.in{
          color: var(--c4);
        }
      }
      .time-line{
        margin-top: calc(var(--gap) * 4);
        font-size:var(--fs-md);
        line-height:var(--lh-md);
        color: var(--g6);
      }
      &:not(:last-child)::after{
        content: "";
        position: absolute;
        height: 1px;
        bottom: 0;
        left: 0;
        right: 0;
        background: var(--g4);
        transform: scaleY(0.5);
      }
    }
    

  }
}
</style>